<template>
  <div>
    <b-row>
      <b-col
        md="2"
        sm="4"
        class="my-1"
      >
        <b-form-group
          class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Anzeigen pro Seite</label>
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            :options="pageOptions"
            class="w-50"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="4"
        sm="8"
        class="my-1"
      />

      <b-col
        md="6"
        class="my-1"
      >
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInput"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              placeholder="Flugnummer"
            />
            <b-input-group-append>
              <b-button
                :disabled="!filter"
                @click="filter = ''"
              >
                Leeren
              </b-button>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2 btn-success"
              @click="New"
            >
              Neuen Flug anlegen
            </b-button>
          </b-input-group>
        </b-form-group>

      </b-col>

      <b-col cols="12">
        <b-table
          striped
          hover
          responsive
          :per-page="perPage"
          :items="items"
          :fields="fields"
          @row-clicked="Click"
        >
          <template #cell(Drivers)="data">
            <b-badge style="color: #e8e8e8; background: #2d839e">
              {{ DriverList[0].Name }}
            </b-badge>
          </template>
        </b-table>
      </b-col>

      <b-col
        cols="12"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          size="sm"
          class="my-0"
        />
      </b-col>
    </b-row>

    <b-modal
      hide-footer
      id="modal-edit-plan"
      centered
      size="lg"
      title="Flug bearbeiten"
    >
      <b-row>
        <b-col
          md="12"
          xl="12"
          class="mb-1"
        >
          <b-row>
            <b-col
              md="4"
              xl="4"
              class="mb-1"
            >
              <b-form-group
                label="Flugnr."
              >
                <b-form-input
                    v-model="edit.IataCode" />
              </b-form-group>
            </b-col>

            <b-col
              md="4"
              xl="4"
              class="mb-1"
            >
              <b-form-group
                label="Start"
              >
                <b-form-input
                    v-model="edit.Departure"/>
              </b-form-group>
            </b-col>
            <b-col
              md="4"
              xl="4"
              class="mb-1"
            >
              <b-form-group
                label="Ziel"
              >
                <b-form-input
                    v-model="edit.Arrivals" />
              </b-form-group>
            </b-col>
          </b-row>
          <div v-for="(item, index) in edit.ScheduledTimes">
            <b-row>
              <b-col
                md="6"
                xl="6"
                class="mb-1"
              >
                {{ index }} (Start / Landezeit)
                <cleave
                    id="ReturnPickupTime0"
                    v-model="edit.ScheduledTimes[index]"
                    class="form-control"
                    :raw="false"
                    :options="options.time"
                    placeholder="hh:mm"
                    ref="ReturnPickupTime0"
                />
              </b-col>
              <b-col
                md="6"
                xl="6"
                class="mb-1"
              >

                {{ index }} Pickup (Abholzeit)
                <cleave
                    id="ReturnPickupTime0"
                    v-model="edit.PickupTime[index]"
                    class="form-control"
                    :raw="false"
                    :options="options.time"
                    placeholder="hh:mm"
                    ref="ReturnPickupTime0"
                />
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col
          md="6"
          xl="6"
          class="mb-1"
        >
        </b-col>
      </b-row>

      <div>
        <b-button
            size="sm"
            variant="gradient-danger"
            class="btn-icon"
            @click="DeleteFlight"
        >
          <feather-icon icon="Trash2Icon" />
        </b-button>
        <b-button class=float-right variant="success" @click="Save">
          OK
        </b-button>
      </div>
      <template #modal-footer="{ ok, cancel}">
        <div></div>
      </template>
    </b-modal>
  </div>

</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

import Cleave from 'vue-cleave-component'
export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    Cleave,
  },
  data() {
    return {
      lastClickedRow: -1,
      options: {
        Time2Label: 'Abflug',
        date: {
          date: true,
          delimiter: '.',
          datePattern: ['d', 'm', 'y'],
        },
        time: {
          time: true,
          timePattern: ['h', 'm'],
        },

      },
      edit: {
        FpId: 0,
        IataCode: '',
        Departure: '',
        Arrivals: '',
        Airline: '',
        ScheduledTimes: {
          Mon: '',
          Tue: '',
          Wed: '',
          Thr: '',
          Fri: '',
          Sat: '',
          Sun: '',
        },
        PickupTime: {
          Mon: '',
          Tue: '',
          Wed: '',
          Thr: '',
          Fri: '',
          Sat: '',
          Sun: '',
        }
      },
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      filterTimeout: null,
      fields: [
        {
          key: 'FpId',
          label: 'ID',
        },
        {
          key: 'Airline',
          label: 'Airline',
        },
        {
          key: 'IataCode',
          label: 'Flug (IATA))',
        },
        {
          key: 'Departure',
          label: 'Start',
        },
        {
          key: 'DepartureName',
          label: 'Start',
        },
        {
          key: 'Arrivals',
          label: 'Ziel',
        },
        {
          key: 'ArrivalsName',
          label: 'Ziel',
        },
        {
          key: 'Mo',
          label: 'Mo.',
        },
        {
          key: 'Di',
          label: 'Di.',
        },
        {
          key: 'Mi',
          label: 'Mi.',
        },
        {
          key: 'Do',
          label: 'Do.',
        },
        {
          key: 'Fr',
          label: 'Fr.',
        },
        {
          key: 'Sa',
          label: 'Sa.',
        },
        {
          key: 'So',
          label: 'So.',
        },
      ],
      items: [],
      DriverList: [{
        Name: 'Aktiv',
        Label: 'light-success',
      }, {
        Name: 'Inaktiv',
        Label: 'light-danger',
      }],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({
          text: f.label,
          value: f.key,
        }))
    },
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Flugliste'
    })
    this.LoadList()
    // Set the initial number of items
    this.totalRows = this.items.length
    this.$watch(
      () => this.currentPage,
      val => {
        this.LoadList()
      },
    )

    this.$watch(
        () => this.perPage,
        val => {
          const v = this
          if (this.filterTimeout) clearTimeout(this.filterTimeout)
          this.filterTimeout = setTimeout(() => {
            v.LoadList()
          }, 550)
        },
    )
    this.$watch(
      () => this.filter,
      val => {
        const v = this
        if (this.filterTimeout) clearTimeout(this.filterTimeout)
        this.filterTimeout = setTimeout(() => {
          v.LoadList()
        }, 550)
      },
    )
  },
  methods: {
    Reset() {
      this.edit = {
        FpId: 0,
        IataCode: '',
        Departure: '',
        Arrivals: '',
        Airline: '',
        ScheduledTimes: {
          Mon: '',
          Tue: '',
          Wed: '',
          Thr: '',
          Fri: '',
          Sat: '',
          Sun: '',
        },
        PickupTime: {
          Mon: '',
          Tue: '',
          Wed: '',
          Thr: '',
          Fri: '',
          Sat: '',
          Sun: '',
        }
      }
    },
    DeleteFlight() {
      this.$swal({
        title: 'Ändern',
        text: "Möchten sie diese Adresse wirklich ändern?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, ändern!',
        cancelButtonText: 'Nein, abbrechen',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if(result.isConfirmed) {
          this.$http.delete(`/flightPlan/delete/${this.$route.params.id}/${this.edit.FpId}` )
              .then(resp => {
                if(resp.data.success) {
                  this.$bvModal.hide('modal-edit-plan')
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Flug (' + this.edit.IataCode  + ') wurde gelöscht.',
                      icon: 'EditIcon',
                      variant: 'warning',
                    },
                  })
                  this.items.splice(this.lastClickedRow, 1)
                  this.Reset();
                }
              })
              .catch(err => {
                console.error(err)
              })
        }
      })

    },
    New() {
      this.Reset();
      this.$bvModal.show('modal-edit-plan')
    },
    Click(record, index) {
      this.lastClickedRow = index
      this.LoadFlight(record.FpId)
      this.$bvModal.show('modal-edit-plan')
    },
    Save() {
      let fCount = 0
      for (const [key, value] of Object.entries( this.edit.ScheduledTimes)) {
        if(value.length !== 0 && (value.length !== 5 || value.charAt(2) !== ":")) {
          console.log(`${key}: ${value}`);
          fCount++;
        }
      }
      for (const [key, value] of Object.entries( this.edit.PickupTime)) {
        if(value.length !== 0 && (value.length !== 5 || value.charAt(2) !== ":")) {
          console.log(`${key}: ${value}`);
          fCount++;
        }
      }
      if(fCount > 0) {
        this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Info',
                text: 'Es gibt ' + fCount + ' fehlerhafte eingaben.',
                variant: 'danger',
              },
            },
            {
              timeout: 20000,
            })
      }
      let data = {
        FpId: this.edit.FpId,
        IataCode: this.edit.IataCode,
        Departure: this.edit.Departure,
        Arrivals: this.edit.Arrivals,
        Airline: this.edit.Airline,
        ScheduledTimes: {
          1: this.edit.ScheduledTimes["Mon"] ? this.edit.ScheduledTimes["Mon"] + ':00' : '00:00:33',
          2: this.edit.ScheduledTimes["Tue"] ? this.edit.ScheduledTimes["Tue"] + ':00' : '00:00:33',
          3: this.edit.ScheduledTimes["Wed"] ? this.edit.ScheduledTimes["Wed"] + ':00' : '00:00:33',
          4: this.edit.ScheduledTimes["Thr"] ? this.edit.ScheduledTimes["Thr"] + ':00' : '00:00:33',
          5: this.edit.ScheduledTimes["Fri"] ? this.edit.ScheduledTimes["Fri"] + ':00' : '00:00:33',
          6: this.edit.ScheduledTimes["Sat"] ? this.edit.ScheduledTimes["Sat"] + ':00' : '00:00:33',
          0: this.edit.ScheduledTimes["Sun"] ? this.edit.ScheduledTimes["Sun"] + ':00' : '00:00:33',
        },
        PickupTime: {
          1: this.edit.PickupTime["Mon"] ? this.edit.PickupTime["Mon"] + ':00' : '00:00:33',
          2: this.edit.PickupTime["Tue"] ? this.edit.PickupTime["Tue"] + ':00' : '00:00:33',
          3: this.edit.PickupTime["Wed"] ? this.edit.PickupTime["Wed"] + ':00' : '00:00:33',
          4: this.edit.PickupTime["Thr"] ? this.edit.PickupTime["Thr"] + ':00' : '00:00:33',
          5: this.edit.PickupTime["Fri"] ? this.edit.PickupTime["Fri"] + ':00' : '00:00:33',
          6: this.edit.PickupTime["Sat"] ? this.edit.PickupTime["Sat"] + ':00' : '00:00:33',
          0: this.edit.PickupTime["Sun"] ? this.edit.PickupTime["Sun"] + ':00' : '00:00:33',
        }
      }
      console.log(this.edit)
      this.$http.post(`/flightPlan/add/flight/${this.$route.params.id}`, JSON.stringify(data)).then(resp => {
        console.log(resp)
        if(resp.data.success) {
          this.Reset();
          this.$bvModal.hide('modal-edit-plan')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Ok',
              icon: 'EditIcon',
              text: 'Flug wurde gespeichert.',
              variant: 'success',
            },
          })
        }
      }).catch(err => {
        console.error(err)
      })
    },
    LoadFlight(id) {
      this.$http.get(`/flightPlan/get/${this.$route.params.id}/${id}`)
          .then(resp => {
            if(!resp.data.success) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'EditIcon',
                  text: 'Fehler beim Laden.',
                  variant: 'error',
                },
              })
              return
            }
            const i = resp.data.data
            const data = {
              FpId: i.FpId,
              IataCode: i.IataCode,
              Departure: i.Departure,
              DepartureName: i.DepartureName,
              Arrivals: i.Arrivals,
              ArrivalsName: i.ArrivalsName,
              Airline: i.Airline,
              ScheduledTimes: {
                Mon: i.ScheduledTimes[1] ? `${i.ScheduledTimes[1].substring(0, 5)}` : '',
                Tue: i.ScheduledTimes[2] ? `${i.ScheduledTimes[2].substring(0, 5)}` : '',
                Wed: i.ScheduledTimes[3] ? `${i.ScheduledTimes[3].substring(0, 5)}` : '',
                Thr: i.ScheduledTimes[4] ? `${i.ScheduledTimes[4].substring(0, 5)}` : '',
                Fri: i.ScheduledTimes[5] ? `${i.ScheduledTimes[5].substring(0, 5)}` : '',
                Sat: i.ScheduledTimes[6] ? `${i.ScheduledTimes[6].substring(0, 5)}` : '',
                Sun: i.ScheduledTimes[0] ? `${i.ScheduledTimes[0].substring(0, 5)}` : '',
              },
              PickupTime: {
                Mon: i.PickupTime[1] ? `${i.PickupTime[1].substring(0, 5)}` : '',
                Tue: i.PickupTime[2] ? `${i.PickupTime[2].substring(0, 5)}` : '',
                Wed: i.PickupTime[3] ? `${i.PickupTime[3].substring(0, 5)}` : '',
                Thr: i.PickupTime[4] ? `${i.PickupTime[4].substring(0, 5)}` : '',
                Fri: i.PickupTime[5] ? `${i.PickupTime[5].substring(0, 5)}` : '',
                Sat: i.PickupTime[6] ? `${i.PickupTime[6].substring(0, 5)}` : '',
                Sun: i.PickupTime[0] ? `${i.PickupTime[0].substring(0, 5)}` : '',
              }
            }
            this.edit = data
          })
          .catch(err => {
            console.error(err)
          })
    },
    LoadList() {

      console.log(this.$route.params.id)

      this.items = []
      const c1 = (this.currentPage - 1) * this.perPage

      let url = `/flightPlan/list?planId=${this.$route.params.id}&from=${c1}&count=${this.perPage}`
      if (this.filter && this.filter !== '') {
        url = `/flightPlan/list/filter?planId=${this.$route.params.id}&filter=${this.filter}`
      }
      let id = 0;
      this.$http.get(url)
        .then(resp => {
          this.totalRows = resp.data.info.fullEntries
          resp.data.list.forEach(i => {
            i = i.Value
            console.log(i.FpId)
            const data = {
              FpId: i.FpId,
              IataCode: i.IataCode,
              Departure: i.Departure,
              DepartureName: i.DepartureName,
              Arrivals: i.Arrivals,
              ArrivalsName: i.ArrivalsName,
              Airline: i.Airline,
              Mo: i.ScheduledTimes[1] ? `${i.ScheduledTimes[1].substring(0, 5)} (${i.PickupTime[1].substring(0, 5)})` : '',
              Di: i.ScheduledTimes[2] ? `${i.ScheduledTimes[2].substring(0, 5)} (${i.PickupTime[2].substring(0, 5)})` : '',
              Mi: i.ScheduledTimes[3] ? `${i.ScheduledTimes[3].substring(0, 5)} (${i.PickupTime[3].substring(0, 5)})` : '',
              Do: i.ScheduledTimes[4] ? `${i.ScheduledTimes[4].substring(0, 5)} (${i.PickupTime[4].substring(0, 5)})` : '',
              Fr: i.ScheduledTimes[5] ? `${i.ScheduledTimes[5].substring(0, 5)} (${i.PickupTime[5].substring(0, 5)})` : '',
              Sa: i.ScheduledTimes[6] ? `${i.ScheduledTimes[6].substring(0, 5)} (${i.PickupTime[6].substring(0, 5)})` : '',
              So: i.ScheduledTimes[0] ? `${i.ScheduledTimes[0].substring(0, 5)} (${i.PickupTime[0].substring(0, 5)})` : '',
            }
            this.items.push(data)
          })
        })
        .catch(err => {
          console.error(err)
        })
    },
  },
}
</script>
